import React, { useState } from "react";
import "../App.css";
import QuestionNumbers from "../Components/QuestionNumbers";
import { Row, Col } from "react-bootstrap";
import CountdownTimer from "../Components/CountdownTimer";
import McqQuestion from "../Components/McqQuestion";

function PreviewPage() {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  return (
    <>
      <div style={{ background: "#263F86", fontFamily: "Manrope-Regular" }}>
        <div className="custom-container">
          <div className="row">
            <div className="col-md-12">
              <h4 className="text-white mt-3">
                Preview All the Questions & Answers
              </h4>
              <p className="text-white">Previewing as Admin</p>
            </div>
          </div>
        </div>
      </div>
      <div className="container" style={{ fontFamily: "Manrope-Regular" }}>
        <Row className="mb-2">
          <Col md={6} className="d-flex justify-content-start">
            <h6 className="mt-3">
              You can preview all the questions from this assessment
            </h6>
          </Col>
          <Col md={6} className="d-flex justify-content-end">
            <p className="mt-3 fw-semibold spacing">Time Left:</p>
            <CountdownTimer duration={3600} />
          </Col>
        </Row>
      </div>
      <div className="container mt-3">
        <QuestionNumbers onQuestionClick={setCurrentQuestionIndex} />
      </div>
      <McqQuestion
        currentQuestionIndex={currentQuestionIndex}
        setCurrentQuestionIndex={setCurrentQuestionIndex}
      />
    </>
  );
}

export default PreviewPage;
